<template>
  <v-container :fluid="true">
    <!-- 会員入力画面 { -->
    <v-card v-if="isWordListReady && !confirmPage && !displayCompletedDialog" :flat="true">
      <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
        {{ wordList.lbl_member_regist }}
      </v-card-title>
      <input
        ref="fileInput"
        type="file"
        accept="text/csv"
        style="display: none"
        @change="onChangeFileUpload"
      />
      <!-- アクションメニュー -->
      <v-row align="center" justify="end">
        <v-menu open-on-hover location="bottom">
          <template #activator="{ props }">
            <v-btn variant="text" color="black" v-bind="props">
              {{ wordList.btn_action }}
              <v-icon>mdi-cog</v-icon>
            </v-btn>
          </template>
          <v-list width="280" class="pl-5">
            <v-list-item-title
              style="cursor: pointer"
              @click="triggerFileInput"
            >
              <v-icon class="mr-2">mdi-cloud-upload</v-icon>
              {{ wordList.lbl_csv_upload_member }}
            </v-list-item-title>
          </v-list>
        </v-menu>
      </v-row>
      <Form v-slot="{ meta }" :initial-values="{ ...createMember }" :key="formKey">
        <v-card-text>
          <v-card :flat="true">
            <v-card-text>
              <!-- 住所 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end"
                    >{{ wordList.lbl_delivery_destination_address }}
                    <ImportantChip></ImportantChip
                  ></v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" class="color_black">
                  {{
                    createMember.zip_code !== null && createMember.zip_code
                      ? "〒"
                      : ""
                  }}{{ createMember.zip_code.substring(0, 3)
                  }}{{ createMember.zip_code ? "-" : ""
                  }}{{ createMember.zip_code.substring(3) }}
                  {{ createMember.address1 }}
                </v-col>
              </v-row>
              <!-- 住所変更ボタン -->
              <v-row class="mt-0">
                <v-col cols="12" sm="4" md="4" lg="4"></v-col>
                <v-col class="pl-2 pt-0"
                  ><v-btn
                    size="small"
                    color="primary"
                    variant="outlined"
                    @click="onClickAddressUpdate"
                  >
                    {{ wordList.btn_address_change }}
                  </v-btn>
                </v-col>
              </v-row>
              <!-- 配達先住所(番地) -->
              <v-row>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_destination_address_detail }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                    <Field
                      v-slot="{ field, errors }"
                      name="address2"
                      :label="wordList.lbl_delivery_destination_address_detail"
                      rules="required|max:100"
                    >
                      <v-text-field
                        :model-value="field.value ?? createMember.address2"
                        :placeholder="
                          wordList.plc_delivery_destination_address_detail
                        "
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="!(createMember.address1.length > 0)"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            createMember.address2 = val;
                          }
                        "
                        @blur="() => field.onBlur()"
                      ></v-text-field>
                    </Field>
                </v-col>
              </v-row>
              <!-- 建物名 部屋番号 -->
              <v-row>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_room_num }}
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                    <Field
                      v-slot="{ field, errors }"
                      name="address3"
                      :label="wordList.lbl_room_num"
                      rules="max:100"
                    >
                      <v-text-field
                        :model-value="field.value ?? createMember.address3"
                        :placeholder="wordList.plc_room_num"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            createMember.address3 = val;
                          }
                        "
                        @blur="() => field.onBlur()"
                      ></v-text-field>
                    </Field>
                </v-col>
              </v-row>
              <!-- お名前(漢字)-->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_name_kanji }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3">
                    <Field
                      v-slot="{ field, errors }"
                      name="name1"
                      :label="wordList.lbl_family_name_kanji"
                      rules="required|min:1|max:100"
                    >
                      <v-text-field
                        :model-value="field.value ?? createMember.name1"
                        :placeholder="wordList.plc_family_name_kanji"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            createMember.name1 = val;
                          }
                        "
                        @blur="() => field.onBlur()"
                      ></v-text-field>
                    </Field>
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3">
                    <Field
                      v-slot="{ field, errors }"
                      name="name2"
                      :label="wordList.lbl_first_name_kanji"
                      rules="required|min:1|max:100"
                    >
                      <v-text-field
                        :model-value="field.value ?? createMember.name2"
                        :placeholder="wordList.plc_first_name_kanji"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            createMember.name2 = val;
                          }
                        "
                        @blur="() => field.onBlur()"
                      ></v-text-field>
                    </Field>
                </v-col>
              </v-row>
              <!-- お名前(かな) -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_name_kana }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3">
                    <Field
                      v-slot="{ field, errors }"
                      name="name_kana1"
                      :label="wordList.lbl_family_name_kana"
                      rules="required|min:1|max:100|regex:^[ぁ-んー]+$"
                    >
                      <v-text-field
                        :model-value="field.value ?? createMember.name_kana1"
                        :placeholder="wordList.plc_family_name_kana"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            createMember.name_kana1 = val;
                          }
                        "
                        @blur="() => field.onBlur()"
                      ></v-text-field>
                    </Field>
                </v-col>
                <v-col cols="6" sm="3" md="3" lg="3">
                    <Field
                      v-slot="{ field, errors }"
                      name="name_kana2"
                      :label="wordList.lbl_first_name_kana"
                      rules="required|min:1|max:100|regex:^[ぁ-んー]+$"
                    >
                      <v-text-field
                        :model-value="field.value ?? createMember.name_kana2"
                        :placeholder="wordList.plc_first_name_kana"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            createMember.name_kana2 = val;
                          }
                        "
                        @blur="() => field.onBlur()"
                      ></v-text-field>
                    </Field>
                </v-col>
              </v-row>
              <!-- 電話番号 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_tel }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3">
                    <Field
                      v-slot="{ field, errors }"
                      name="phone"
                      :label="wordList.lbl_tel"
                      rules="required|numeric|min:10|max:11"
                    >
                      <v-text-field
                        :model-value="field.value ?? createMember.phone"
                        :placeholder="wordList.plc_tel"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            createMember.phone = val;
                          }
                        "
                        @blur="() => field.onBlur()"
                      ></v-text-field>
                    </Field>
                </v-col>
              </v-row>
              <!-- ハウスカード番号 -->
              <v-row v-if="house_card_display == 1" dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center"
                    v-if="house_card_required == 1"
                    dense
                      class="form-label-row mr-3 justify-sm-end"
                  >
                    {{ wordList.lbl_house_card }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                  <v-row align="center" v-else dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_house_card }}
                  </v-row>
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3">
                    <Field
                      v-slot="{ field, errors }"
                      name="house_card"
                      :label="wordList.lbl_house_card"
                      :rules="house_card_validation"
                    >
                      <v-text-field
                        :model-value="field.value ?? createMember.house_card"
                        :placeholder="wordList.plc_house_card"
                        density="compact"
                        variant="outlined"
                        :error-messages="errors"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            createMember.house_card = val;
                          }
                        "
                        @blur="() => field.onBlur()"
                      ></v-text-field>
                    </Field>
                </v-col>
              </v-row>
              <!-- 会員備考 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_memo_member }}
                  </v-row>
                </v-col>
                <v-col cols="12" sm="7" md="7" lg="7">
                    <Field v-slot="{ field, errors }" name="notes" :label="wordList.lbl_memo_member">
                      <v-textarea
                        :model-value="field.value ?? createMember.notes"
                        :placeholder="wordList.plc_memo_member"
                        variant="outlined"
                        :error-messages="errors"
                        :disabled="isDisabled"
                        @update:model-value="
                          (val) => {
                            field.onChange(val);
                            createMember.notes = val;
                          }
                        "
                        @blur="() => field.onBlur()"
                      >
                      </v-textarea>
                    </Field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-center flex-wrap">
              <!-- 登録手続きへボタン -->
              <v-btn
                variant="flat"
                color="primary"
                class="btn_width_1 my-2 mx-2"
                :disabled="!meta.valid || !(createMember && createMember.address1)"
                @click="onClickUpdate"
              >
                <v-icon>mdi-playlist-edit</v-icon>
                {{ wordList.btn_regist_confirm }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </Form>
    </v-card>
    <!-- } 会員登録画面 -->
    <!-- 会員登録確認 { -->
    <v-card v-if="isWordListReady && confirmPage && !displayCompletedDialog" :flat="true">
      <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
        {{ wordList.lbl_member_confirm }}
      </v-card-title>
      <v-card-text class="confirm-display-text">
        <!-- 配達先住所 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_destination_address }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ createMember.zip_code ? "〒" : ""
            }}{{ createMember.zip_code.substring(0, 3)
            }}{{ createMember.zip_code ? "-" : ""
            }}{{ createMember.zip_code.substring(3) }}
            {{ createMember.address1 }}
          </v-col>
        </v-row>
        <!-- 配達先住所(番地) -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_destination_address_detail }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ createMember.address2 }}
          </v-col>
        </v-row>
        <!-- 建物名 部屋番号 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_room_num }}
            </v-row></v-col
          >
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ createMember.address3 }}
          </v-col>
        </v-row>
        <!-- お名前(漢字) -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_name_kanji }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ createMember.name1 }}{{ createMember.name2 }}
          </v-col>
        </v-row>
        <!-- お名前(かな) -->
        <v-row dense class="mb-3">
          <!-- お名前(かな) -->
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_name_kana }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1"
            >{{ createMember.name_kana1 }}{{ createMember.name_kana2 }}</v-col
          >
        </v-row>
        <!-- 電話番号 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_tel }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ createMember.phone }}
          </v-col>
        </v-row>
        <!-- ハウスカード番号 -->
        <v-row v-if="house_card_display == 1" dense class="mb-3">
          <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
            <v-row align="center"
              v-if="house_card_required == 1"
              dense
                class="form-label-row mr-3 justify-sm-end"
            >
              {{ wordList.lbl_house_card }}
              <ImportantChip></ImportantChip>
            </v-row>
            <v-row align="center" v-else dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_house_card }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="8" md="8" lg="8" class="text-body-1">
            {{ createMember.house_card }}
          </v-col>
        </v-row>
        <!-- 会員備考 -->
        <v-row dense class="mb-3">
          <v-col cols="4" sm="4" md="4" lg="4" class="font-weight-black"
            ><v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_memo_member }}
            </v-row>
          </v-col>
          <v-col cols="8" sm="8" md="8" lg="8" class="text-body-1">
            {{ createMember.notes }}
          </v-col>
          <v-col offset="4" cols="8" class="text-body-1 text-caption">
            {{ messageMemberNotes }}
          </v-col>
        </v-row>
      </v-card-text>
      <!-- 編集処理時のボタン { -->
      <v-card-actions v-if="processFlag < 2" class="justify-center flex-wrap">
        <v-btn
          variant="flat"
          color="primary"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmUpdateOk"
        >
          <v-icon>mdi-playlist-edit</v-icon>
          {{ wordList.btn_member_regist }}</v-btn
        >
      </v-card-actions>
      <v-card-actions v-if="processFlag < 2" class="justify-center">
        <v-btn
          variant="flat"
          color="return"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmUpdateCancel"
        >
          <v-icon>mdi-arrow-left</v-icon>
          {{ wordList.btn_return }}
        </v-btn>
      </v-card-actions>
      <!-- } 登録処理時のボタン -->
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <!-- } 会員登録確認 -->
    <!-- 会員登録完了 { -->
    <v-card v-if="isWordListReady && displayCompletedDialog" :flat="true">
      <v-card
        v-if="
          createMemberMutation !== null && createMemberMutation !== undefined
        "
        flat
      >
        <v-card-title>{{ wordList.lbl_member_regist_complete }}</v-card-title>
        <v-card-text>
          <v-row class="pt-5">
            <v-col class="font-weight-black">
              {{ wordList.lbl_member_regist_complete_msg }}
            </v-col>
          </v-row>
          <v-row class="ml-5">
            <!-- 会員ID -->
            <v-col cols="6" class="font-weight-black"
              >{{ wordList.lbl_member_id }} :{{
                createMemberMutation.createMember.member_id
              }}
            </v-col>
          </v-row>
          <v-row class="ml-5">
            <!-- 会員名かな -->
            <v-col cols="6" class="font-weight-black"
              >{{ wordList.lbl_name_kanji }} :{{
                createMemberMutation.createMember.name1
              }}
              {{ createMemberMutation.createMember.name2 }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn variant="flat" color="return" class="px-16" @click="onClickCompletedGoStart">
            {{ wordList.btn_member_regist_return }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-card>
    <!-- } 会員登録完了 -->
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
    <AddressSelectorDialog
      :address-dialog="addressDialog"
      :area-dialog="areaDialog"
      :toggle-mode="btnNonMemberToggle"
      :zip-code="zip_code"
      :pref="prefSelectValue"
      :pref-list-items="prefListItems"
      :selected-address="selectedAddressLabel"
      :original-city="originalCityAddress"
      :city-block-list="cityBlockList ?? null"
      :section-block-list="sectionBlockList ?? null"
      :block-list="addressDialogBlockList"
      :click-disabled="clickMode"
      :area-not-select-message="areaNotSelectLabel"
      :errors="addressDialogErrors"
      :word-list="wordList"
      @update:address-dialog="onAddressDialogUpdate"
      @update:area-dialog="onAreaDialogUpdate"
      @update:zip-code="onZipCodeUpdate"
      @update:pref="onPrefUpdate"
      @toggle-zip="onClickToggleZip"
      @toggle-pref="onClickTogglePref"
      @zip-input="onZipCodeInput()"
      @pref-input="onPrefSelectInput"
      @search="onClickDeliveryRequestAndNewMember"
      @close-address="onCloseAddressDialog"
      @area-return="onClickAreaDialogReturn"
      @select-city="onClickCityBlockLink"
      @select-section="onClickSectionBlockLink"
      @select-block="onClickAddressBlockLink"
    />
    <!-- { ダイアログ -->
    <AlertDialog
      v-model="messagedialog"
      :title="wordList.lbl_delivery_regist"
      :message="message"
      type="info"
    />
    <!-- } ダイアログ -->
    <!-- アップロード中 ダイアログ { -->
    <v-dialog v-model="uploadDialog" persistent width="40%">
      <v-card>
        <v-card-title>アップロード</v-card-title>
        <v-card-text>
          <v-container style="height: 200px">
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12">
                アップロード中...
              </v-col>
              <v-col cols="6">
                <v-progress-linear
                  color="deep-purple-accent-4"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- } アップロード中 ダイアログ -->
  </v-container>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";

// ------ Vee-Validate ------
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import { required, max, min, numeric, length, regex } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";

// ------ Composables ------
import { useMemberRegisterUiState } from "./composables/useMemberRegisterUiState";
import { useMemberRegisterForm } from "./composables/useMemberRegisterForm";
import { useMemberRegisterInit } from "./composables/useMemberRegisterInit";
import { useMemberRegisterAddress } from "./composables/useMemberRegisterAddress";
import { useMemberRegisterActions } from "./composables/useMemberRegisterActions";
import { useMemberRegisterUpload } from "./composables/useMemberRegisterUpload";
import AddressSelectorDialog from "@/components/address-selector/AddressSelectorDialog.vue";
import type {
  AddressBlockItem as SharedAddressBlockItem,
  AddressSelectionErrors,
} from "@/components/address-selector/types";

// ------ Local Components ------
import ImportantChip from "@/components/ImportantChip.vue";
import AlertDialog from "@/components/AlertDialog.vue";

// ============================
// Vee-Validate rules / locale
// ============================
defineRule("required", required);
defineRule("max", max);
defineRule("min", min);
defineRule("numeric", numeric);
defineRule("length", length);
defineRule("regex", regex);
configure({
  generateMessage: localize({
    ja,
  }),
});
setLocale('ja');

// ============================
// state
// ============================

// -------------------------------
// 画面UI状態
// -------------------------------
const {
  errdialog,
  errMessage,
  confirmPage,
  processFlag,
  addressDialog,
  areaDialog,
  uploadDialog,
  messagedialog,
  message,
  displayCompletedDialog,
  overlay,
} = useMemberRegisterUiState();

// -------------------------------
// フォーム State
// -------------------------------
const {
  createMember,
  memberCreateInput,
  createMemberMutation,
  savedTmpMemberId,
  formKey,
  isDisabled,
  house_card_display,
  house_card_validation,
  house_card_required,
  memberNotesBefore,
  messageMemberNotes,
  logInput,
  prefListItems,
  blockList,
  zipAddressList,
  sectionBlockList,
  zip_code,
  prefSelectValue,
  errorZipCode,
  clickMode,
  unassignedBlockList,
  btnNonMemberToggle,
  userErrorMessage,
  errorPrefSelect,
  zipCodeFromPref,
  cityBlockList,
  originalAddress,
  originalCityAddress,
  originalSectionAddress,
  fileInput,
  wordList,
  isWordListReady,
} = useMemberRegisterForm();

// -------------------------------
// 初期化ロジック
// -------------------------------
const {
  initialize,
  initOnMounted,
} = useMemberRegisterInit({
  errdialog,
  errMessage,
  createMember,
  house_card_display,
  house_card_validation,
  house_card_required,
  formKey,
  savedTmpMemberId,
  confirmPage,
  displayCompletedDialog,
  zip_code,
  prefSelectValue,
  btnNonMemberToggle,
});

// -------------------------------
// 住所選択ロジック
// -------------------------------
const {
  onClickAddressUpdate,
  onCloseAddressDialog,
  onClickAreaDialogReturn,
  onZipCodeInput,
  onClickToggleZip,
  onClickTogglePref,
  onPrefSelectInput,
  onClickDeliveryRequestAndNewMember,
  onClickCityBlockLink,
  onClickSectionBlockLink,
  onClickAddressBlockLink,
} = useMemberRegisterAddress({
  errdialog,
  errMessage,
  createMember,
  addressDialog,
  areaDialog,
  zip_code,
  prefSelectValue,
  prefListItems,
  btnNonMemberToggle,
  errorZipCode,
  errorPrefSelect,
  userErrorMessage,
  clickMode,
  zipCodeFromPref,
  cityBlockList,
  sectionBlockList,
  blockList,
  zipAddressList,
  originalAddress,
  originalCityAddress,
  originalSectionAddress,
  unassignedBlockList,
  wordList,
});

// -------------------------------
// 登録・確認・完了アクション
// -------------------------------
const {
  onClickUpdate,
  onClickConfirmUpdateCancel,
  onClickConfirmUpdateOk,
  onClickCompletedGoStart,
} = useMemberRegisterActions({
  errdialog,
  errMessage,
  overlay,
  confirmPage,
  processFlag,
  displayCompletedDialog,
  createMember,
  memberCreateInput,
  createMemberMutation,
  memberNotesBefore,
  messageMemberNotes,
  house_card_display,
  savedTmpMemberId,
  logInput,
  wordList,
  initialize,
});

// -------------------------------
// CSVアップロード
// -------------------------------
const {
  triggerFileInput,
  onChangeFileUpload,
} = useMemberRegisterUpload({
  overlay,
  uploadDialog,
  messagedialog,
  message,
  fileInput,
});

// -------------------------------
// 配達対象外区画存在メッセージ取得＆置換
// -------------------------------
const areaNotSelectLabel = computed(() => {
  const hasUnassignedInCurrentBlocks = (blockList.value ?? []).some(
    (block) => block && !block.enabled
  );
  if (!hasUnassignedInCurrentBlocks || unassignedBlockList.value.length === 0) {
    return "";
  }
  const unassignedBlocks = unassignedBlockList.value.join(", ");
  return wordList.value.lbl_area_not_select?.replace("{{s}}", unassignedBlocks) || "";
});

const selectedAddressLabel = computed(() => {
  return `${prefSelectValue.value}${originalCityAddress.value}${originalSectionAddress.value}`;
});

const addressDialogBlockList = computed<SharedAddressBlockItem[]>(() => {
  return (blockList.value ?? []).filter(
    (value): value is SharedAddressBlockItem => value !== null && value !== undefined
  );
});

const addressDialogErrors = computed<AddressSelectionErrors>(() => {
  return {
    zip: errorZipCode.value,
    pref: errorPrefSelect.value,
    general: userErrorMessage.value,
  };
});

const onAddressDialogUpdate = (value: boolean): void => {
  addressDialog.value = value;
};

const onAreaDialogUpdate = (value: boolean): void => {
  areaDialog.value = value;
};

const onZipCodeUpdate = (value: string): void => {
  zip_code.value = value;
};

const onPrefUpdate = (value: string): void => {
  prefSelectValue.value = value;
};

// -------------------------------
// マウント時処理
// -------------------------------
onMounted(async (): Promise<void> => {
  await initOnMounted(wordList.value);
});
</script>

<style scoped></style>
